import * as resultsApi from './results.api'


export default {...resultsApi}